import { PlatformInfo, PlatformType } from '@root/config';
import { FormBuilder, FormGroup } from '@angular/forms';

interface GuideInfo {
  address_info: string;
  guide_url: string;
  lock_info: string;
  wifi_info: string;
}

export class PriceModel {
  thirdparty_type: PlatformType;
  sync_status: number;
  is_shelf: number; // 判断是否上架。
  fail_message: '';
  origin_house_id: '';
  constructor(options?: any) {
    this.is_shelf = options.is_shelf || 0;
    this.thirdparty_type = options.thirdparty_type || PlatformType.Airbnb;
    this.sync_status = options.sync_status || 0;
    this.fail_message = options.fail_message || '';
    this.origin_house_id = options.origin_house_id || '';
  }

  get thirdparty_info() {
    return PlatformInfo[this.thirdparty_type];
  }
}

export class GroupModel {
  id: number;
  name: string;
  constructor(options?: any) {
    this.id = options.id || 0;
    this.name = options.name || '';
  }
}

export class HouseModel {
  id: number;
  house_title: string;
  house_address: string;
  cover_picture: string;
  thirdparty_types: Array<number>;
  groups: Array<GroupModel>;
  prices: Array<PriceModel>;
  checked: boolean;
  is_editing: boolean;
  platforms?: Array<any>;
  failMessages?: Array<any>;
  house_type_title?: string;
  has_house_prices: boolean;
  is_master_house: boolean;
  is_slave_house: boolean;
  stop_auto_managed: boolean;
  checkin_guide: GuideInfo;
  constructor(options?: any) {
    this.id = options.id || '';
    this.groups = options.groups || [];
    this.prices = options.prices || [];
    this.checked = options.checked || false;
    this.is_editing = options.is_editing || false;
    this.house_type_title = options.house_type_title || false;
    this.cover_picture = options.cover_picture || '';
    this.house_title = options.house_title || '';
    this.has_house_prices = options.has_house_prices || false;
    this.is_master_house = options.is_master_house || false;
    this.is_slave_house = options.is_slave_house || false;
    this.stop_auto_managed = options.stop_auto_managed || false;
    this.checkin_guide = options.checkin_guide;
  }
}

export class HouseListProps {
  // platforms = Object.values(PLATFORM_TYPE_INFO);

  // searchForm: FormGroup = this.fb.group({
  //   title: "",
  //   group: -1,
  //   subAccount: null,
  // });

  houseList: Array<HouseModel> = [];
  constructor() {}
}
